import React, { useState } from 'react';
import { BiTrash } from "react-icons/bi";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { Table } from 'react-bootstrap';
import Select from 'react-select';

const ProductPrice = (props) => {
  const [localSize, setLocalSize] = useState({
    name: '',
    mrp: '',
    price: '',
    stock: '',
    sku: ''
  });

  const handleAddSize = () => {
    if (!localSize.name || !localSize.mrp || !localSize.price || !localSize.stock) {
      alert("Please fill all required size fields (Name, MRP, Price, Stock)");
      return;
    }
    
    // Add to parent state
    if (typeof props.setMultiProductList === 'function') {
      props.setMultiProductList([...(props.multiProductList || []), localSize]);
    }
    
    // Reset local form
    setLocalSize({ name: '', mrp: '', price: '', stock: '', sku: '' });
  };

  const handleRemoveSize = (index) => {
    const newList = [...(props.multiProductList || [])];
    newList.splice(index, 1);
    if (typeof props.setMultiProductList === 'function') {
      props.setMultiProductList(newList);
    }
  };

  return (
    <div>
      <div className="container mt-4 mb-4">
        {/* User-Friendly Guidance Banner */}
        <div className="alert alert-info d-flex align-items-center mb-4 shadow-sm" style={{ borderRadius: '10px', backgroundColor: '#eef7ff', borderColor: '#b6e0fe' }}>
          <div style={{ fontSize: '20px', marginRight: '15px' }}>💡</div>
          <div style={{ fontSize: '14px', color: '#084298' }}>
            <strong>{props.sizeOption == '1' ? 'Single Size Pricing' : 'Multi-Size Variant Management'}</strong>
            <br />
            {props.sizeOption == '1'
              ? 'Enter MRP, selling price, stock, and optional SKU code for this item.'
              : 'Add size variants (e.g. S, M, L, 42) along with individual SKU codes, MRP, selling price, and stock for each variation.'}
          </div>
        </div>

        {props.sizeOption && props.sizeOption == '1' ? (
          <div className="row mt-2 g-3">
            <p style={{ fontWeight: "bold" }}>Add Product Price & Stock</p>
            <div className="col-md-3">
              <label className="form-label label-txt"> Product MRP </label>
              <input type="number" className="form-control" onChange={(e) => props.setProductPrice({ ...props.productPrice, mrp: e.target.value })} value={props.productPrice.mrp || ''} />
            </div>
            <div className="col-md-3">
              <label className="form-label label-txt"> Product Price </label>
              <input type="number" className="form-control" onChange={(e) => props.setProductPrice({ ...props.productPrice, price: e.target.value })} value={props.productPrice.price || ''} />
            </div>
            <div className="col-md-3">
              <label className="form-label label-txt">Stock</label>
              <input type="number" className="form-control" onChange={(e) => props.setProductPrice({ ...props.productPrice, stock: e.target.value })} value={props.productPrice.stock || ''} />
            </div>
            <div className="col-md-3">
              <label className="form-label label-txt">SKU Code (Optional)</label>
              <input type="text" className="form-control" placeholder="e.g. SKU-1001" onChange={(e) => props.setProductPrice({ ...props.productPrice, sku: e.target.value })} value={props.productPrice.sku || ''} />
            </div>
          </div>
        ) : (
          <div className="section">
            <div className="row align-items-center">
              <div className="col-md-12 mt-2">
                <div className="card p-4">
                  <h6 className="mb-3 fw-bold">Add Sizes & Variations</h6>
                  <div className="row mb-3 g-2 align-items-center">
                    <div className="col-md-3">
                      {props.productSize && props.productSize.length > 0 ? (
                        <Select
                          options={props.productSize.map(item => ({ label: item.size_name, value: item.size_name }))}
                          menuPosition="fixed"
                          styles={{
                            control: (base) => ({
                              ...base,
                              boxShadow: 'none',
                              cursor: 'pointer'
                            }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 })
                          }}
                          value={localSize.name ? { label: localSize.name, value: localSize.name } : null}
                          onChange={(selected) => setLocalSize({...localSize, name: selected ? selected.value : ''})}
                          isClearable
                          placeholder="Select Size"
                        />
                      ) : (
                        <input type="text" className="form-control" placeholder="Size Name (e.g., XL, 42)" value={localSize.name} onChange={e => setLocalSize({...localSize, name: e.target.value})} />
                      )}
                    </div>
                    <div className="col-md-2">
                      <input type="text" className="form-control" placeholder="SKU (Optional)" value={localSize.sku} onChange={e => setLocalSize({...localSize, sku: e.target.value})} />
                    </div>
                    <div className="col-md-2">
                      <input type="number" className="form-control" placeholder="MRP (₹)" value={localSize.mrp} onChange={e => setLocalSize({...localSize, mrp: e.target.value})} />
                    </div>
                    <div className="col-md-2">
                      <input type="number" className="form-control" placeholder="Price (₹)" value={localSize.price} onChange={e => setLocalSize({...localSize, price: e.target.value})} />
                    </div>
                    <div className="col-md-2">
                      <input type="number" className="form-control" placeholder="Stock" value={localSize.stock} onChange={e => setLocalSize({...localSize, stock: e.target.value})} />
                    </div>
                    <div className="col-md-1 text-end">
                      <button type="button" className="btn btn-primary" onClick={handleAddSize} title="Add Size">
                        <AiOutlinePlusCircle style={{ fontSize: 20 }} />
                      </button>
                    </div>
                  </div>

                  <Table responsive="sm" className="mt-3">
                    <thead>
                      <tr className="text-center">
                        <th>Size Name</th>
                        <th>SKU</th>
                        <th>MRP</th>
                        <th>Price</th>
                        <th>Stock</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody style={{ verticalAlign: 'middle' }} className="text-center">
                      {props.multiProductList && props.multiProductList.length > 0 ? (
                        props.multiProductList.map((item, index) => (
                          <tr key={index}>
                            <td>{item.name}</td>
                            <td>{item.sku || '-'}</td>
                            <td>₹{item.mrp}</td>
                            <td>₹{item.price}</td>
                            <td>{item.stock}</td>
                            <td>
                              <button type="button" style={{ border: 'none', background: 'transparent' }} onClick={() => handleRemoveSize(index)}>
                                <BiTrash style={{ color: 'red', fontSize: 18 }} />
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-muted">No sizes added yet.</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductPrice;